const eventsPerSessionMap = new Map<string, number>();

export function checkMaxEventsPerSessionCount(eventName: string, maxEvents: number): boolean {
    if (eventsPerSessionMap.has(eventName)) {
        const count = getEventsPerSessionCount(eventName);
        if (count >= maxEvents) {
            return false;
        }
        
        eventsPerSessionMap.set(eventName, count + 1);
        
        return true;
    }
    
    eventsPerSessionMap.set(eventName, 1);
    
    return true;
}

export function getEventsPerSessionCount(eventName: string): number {
    return eventsPerSessionMap.get(eventName) ?? 0;
}
